import IconPicker from './IconPicker.vue';
export default IconPicker;
